import React from "react";
import {Input} from "reactstrap";


export default class DateComponent extends React.Component {

  render() {
    return <Input {...this.props}
                  id={this.props.id}
                  type="date"
                  name={this.props.name}
                  value={this.props.value}
                  placeholder={this.props.placeholder}
                  onChange={this.props.onChange}
                  readOnly={this.props.readOnly}

    />
  }
}
